import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AccountingUtilsService {
  public static  originalPayArrayNames = [
    'GrossSalaryFR', 'NetSalaryFR', 'NetPayFR', 'AccumulatorsFR', 'LeaveCountersFR', 'TaxFR', 'NetPayBeforeTaxFR',
    'ImpactTaxableSalaryFR', 'TaxableSalaryFR', 'TitlePayslipFR', 'MandatoryTaxesAndCostsFR',
    'ExemptAndReductionsContribFR', 'OptionalTaxesAndCostsFR'
  ];
}
